import contentStudioInstance from '@/utils/axiosContentStudio';

const contentStudioSubscriptionFetchers = {
  plans: async () => {
    const response = await contentStudioInstance.get(
      '/api/v1/subscriptions/plans'
    );
    return response.data;
  },
  current: async () => {
    const response = await contentStudioInstance.get(
      '/api/v1/subscriptions/current'
    );
    return response.data;
  },
};

export default contentStudioSubscriptionFetchers;
